import {Select} from '@mantine/core';
import {useQuery} from '@tanstack/react-query';
import {fetchRecords} from '../../subscriptions/services/SubscriptionsService';

interface SubscriptionSelectorProps {
    value: string | null;
    onChange: (subscriptionId: string | null) => void;
    customerId: string | null;
    activeOnly?: boolean;
}

export const SubscriptionSelector = ({value, onChange, customerId, activeOnly}: SubscriptionSelectorProps) => {
    const {data, isLoading} = useQuery({
        queryKey: ['subscriptions-selector', customerId],
        queryFn: () => fetchRecords(customerId ? {customerId} : undefined, 100),
        enabled: !!customerId,
    });

    const items = (data?.items || []).filter(s => !activeOnly || s.status === 'active');

    const options = items.map(s => ({
        value: s.id,
        label: `${s.id.slice(-8)} - ${s.status} - ${s.currency?.toUpperCase() || 'N/A'}`,
    }));

    return (
        <Select
            label="Subscription"
            placeholder={!customerId ? 'Select a customer first' : isLoading ? 'Loading...' : 'Select a subscription'}
            data={options}
            value={value}
            onChange={onChange}
            searchable
            disabled={!customerId || isLoading}
        />
    );
};
